export default __webpack_public_path__ + "static/media/vMatic.ce00ca6a.svg";